import { render, staticRenderFns } from "./CancelCourtOrder.vue?vue&type=template&id=40871f34&"
import script from "./CancelCourtOrder.vue?vue&type=script&lang=js&"
export * from "./CancelCourtOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports